import { render, staticRenderFns } from "./ReviewSuccess.vue?vue&type=template&id=4624824a&"
import script from "./ReviewSuccess.vue?vue&type=script&lang=ts&"
export * from "./ReviewSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports